import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Breadcrumb } from '../components/breadcrumbs/breadcrumbs.component';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private readonly _breadcrumbs = new BehaviorSubject<Breadcrumb[]>([]);

  constructor() {}

  set breadcrumbs(val: Breadcrumb[]) {
    this._breadcrumbs.next(val);
  }

  get breadcrumbs() {
    return this._breadcrumbs.value;
  }
}
